<template>
  <div class="padding-card grey">
    <v-row>
      <v-col sm="6">
        <v-card class="padding-card">
          <p class="title-user-scr"> <v-icon> mdi-currency-usd-off </v-icon> Configuración de recargos</p>
          <v-form ref="formSettings" v-model="validForm" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12">
                <v-select
                  v-model="surchargeType"
                  :rules="[rules.required]"
                  :items="['fixed', 'percentage']"
                  label="Tipo de cargo"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                  :rules="surchargeType === 'fixed' ? rules.surchargeFixed : rules.surchargePercentage"
                  type="number"
                  min="0"
                  :max="surchargeType === 'percentage' ? 100 : 10000"
                  v-model="surchargeValue"
                  label="Valor del cargo"
                ></v-text-field>
              </v-col>
            </v-row>
            <br />
            <br />
            <p class="title-user-scr"> <v-icon> mdi-calendar-multiple-check </v-icon> Configuración de reservaciones</p>
            <v-text-field
              :rules="[rules.required]"
              type="number"
              min="1"
              v-model="reservationBlockSize"
              label="Bloque de horas para reservación"
            ></v-text-field>
             <p class="title-user-scr"> <v-icon> mdi-credit-card </v-icon>Pagos con tarjeta </p>
            <v-text-field
              suffix="%"
              type="number"
              min=".01"
              max="100"
              v-model="comisionPagoTarjeta"
              label="Comision"
            ></v-text-field>
          </v-form>
          <br />
          <br />
          <br />
          <v-card-actions>
            <v-btn @click="save" depressed color="#00aff2" dark>Actualizar</v-btn>
            <v-spacer></v-spacer>
            <div style="text-align: right">
              <span style="font-size: 10px"> Última actualización: {{ $dayjs(settings.updatedAt).format('ll') }}</span>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col sm="6">
        <v-form ref="formProfile" v-model="validFormProfile" lazy-validation>
          <v-card style="padding: 25px 25px 25px 25px">
            <p class="font-weight-medium text-h6" style="color: #00aff2">
              <v-icon> mdi-account-lock </v-icon> Editar perfil administrador
            </p>

            <UserAdminForm ref="editUser" :info-user="profile" @ready-to-save="readyToSave = $event" />
            <v-card-actions>
              <v-btn :disabled="!validFormProfile" @click="saveCurrentUser" depressed color="#00aff2" dark>
                Actualizar
              </v-btn>
              <v-spacer></v-spacer>
              <div style="text-align: right">
                <span style="font-size: 10px"> Última actualización: {{ $dayjs(profile.updatedAt).format('ll') }}</span>
              </div>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-row>
      <!-- form-configuracion de plan de mantenimiento -->
      <v-col cols="12" sm="12">
        <v-card class="padding-card">
          
          <div style="display: flex">
            <p class="title-user-scr">
              <v-icon> mdi-cog-sync </v-icon> Configuración de plan de mantenimiento
            </p>

            <ModalNewPlan @exit="close" />
          </div>
          <v-row>
            <v-col>
              <v-select
              v-model="year"
              :items="years"
              item-text="text"
              item-value="value"
              label="Selecciona un año"
              @change="fetchSchedulePayment()"
            ></v-select>
            </v-col>
          </v-row>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th id=""  class="text-left">#</th>
                  <th id=""  class="text-left">Año</th>
                  <th id=""  class="text-left">Concepto</th>
                  <th id=""  class="text-left">Descripción</th>
                  <th id=""  class="text-left">Día de vencimiento</th>
                  <th id=""  class="text-left">Importe </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in months" :key="index">
                  <td style="width: 5%"> {{ item.id }} </td>
                  <td style="width: 5%"> {{ item.paymentYear }} </td>
                  <td style="width: 30%">{{ item.concept }}</td>
                  <td style="width: 30%"> {{ item.description }} {{ item.paymentYear }} </td>
                  <td style="width: 15%"> {{ item.paymentDueDay }} </td>
                  <td style="width: 15%">
                    {{ $currency.format(item.amount) }}
                  </td>     
                   <td style="width: 5%">
                    <ModalMaintenancePaymentsUsers :year="item.paymentYear" :maintenance-fee-id="item.id" />
                  </td>             
                  <td style="width: 5%">
                    <v-btn color="red" small height="30px" width="30px" @click="alertdeleteMaintFee(item)">
                      <v-icon color="white">mdi-delete</v-icon>
                    </v-btn>
                  </td>
                 
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="padding-card">
          <p class="title-user-scr"> <v-icon> mdi-party-popper </v-icon> Configuración de salas de eventos </p>
          <v-autocomplete
            item-text="title"            
            return-object
            v-model="roomSelected"
            @change="newRoomFalse"
            :items="rooms"
            filled
            label="Selecciona un salón para editar"
          >
          </v-autocomplete>

          <p class="title-user-scr">Información del salón</p>
          <v-form ref="formRoom" v-model="validFormRoom" lazy-validation>
            <v-row>
              <v-col sm="6">
                <v-img alt="" :src="roomSelected.imageUrl" />
                <v-file-input
                  dense
                  ref="uploadImage"
                  v-model="image"
                  @change="selectFileRoom"
                  accept="image/*"
                  label="Cambia la imagen del salón"
                ></v-file-input>
                <v-text-field
                  dense
                  v-model="roomSelected.title"
                  :rules="[rules.required]"
                  label="Nombre del salón"
                ></v-text-field>
                <v-text-field dense v-model="roomSelected.subtitle" label="Resumen"></v-text-field>
                <v-row style="margin-top:1em"> 
                  <v-col sm="12"><p class="title-user-scr">Horario de reservación</p>
                    <v-checkbox     
                      v-model="roomSelected.nextDay"                
                      label="Termina día siguiente"
                      color="red"
                      hide-details
                      dense
                    ></v-checkbox>
                  </v-col>
                  <v-col sm="6">
                    <h2>Inicio:</h2>
                    <time-picker  
                    :initialHour="roomSelected.timeStart  || '07:00'"
                    @change="roomSelected.timeStart = $event"                                             
                    ></time-picker>
                  </v-col>
                  <v-col sm="6">
                    <h2>Final:</h2>
                    <time-picker    
                    :initialHour="roomSelected.timeEnd  || '22:00'"
                    @change="roomSelected.timeEnd = $event"                            
                    ></time-picker>
                    <v-messages
                      v-if="timeError"
                      :value="[timeError]"
                      class="err-message"
                    ></v-messages>
                  </v-col>
                </v-row> 
              </v-col>
              <v-col sm="6">
                  <v-textarea
                  dense
                  v-model="roomSelected.description"
                  :rules="[rules.required]"
                  label="Descripción"
                  auto-grow
                  outlined
                  rows="12"
                ></v-textarea>
                 <v-checkbox
                  v-model="roomSelected.noPayment"
                  label="Reservar sin pago"
                  color="red"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="roomSelected.deposit"
                  label="Requiere deposito"
                  color="red"
                  hide-details
                  dense
                ></v-checkbox>
                <v-text-field
                  v-if="roomSelected.deposit"
                  :rules="[rules.required]"
                  prefix="$"
                  v-model="roomSelected.depositAmount"
                  suffix="MXN"
                  min="0"
                  type="number"
                  label="Monto de depósito"
                ></v-text-field>
                <v-text-field
                  prefix="$"
                  v-model="roomSelected.costAmount"
                  :rules="[rules.required]"
                  suffix="MXN"
                  min="100"
                  type="number"
                  label="Costo total"
                ></v-text-field>
                <v-row>
                  <v-col>
                    <v-checkbox
                      v-model="roomSelected.blocked"
                      label="Bloquear reservaciones"
                      color="red"
                      hide-details
                      dense
                    ></v-checkbox>   
                  </v-col>
                  <v-col>
                    <v-text-field
                      :rules="[rules.required]"
                      type="number"
                      min="1"
                      v-model="roomSelected.lapse"
                      label="Bloque de horas para reservación"
                    ></v-text-field>                    
                  </v-col>
                </v-row>                 
                <v-text-field                 
                    v-model="roomSelected.dias_min_reserva"
                    type="number"
                    label="Reservar con anticipacion hasta con el siguiente número de días"
                  ></v-text-field> 
                    
               
              </v-col>    
                                       
            </v-row>
          </v-form>
          <v-card-actions>
            <v-btn v-if="!newPartyRoom" @click="updateRoom" depressed color="#00aff2" dark>Actualizar</v-btn>
            <v-btn v-if="!newPartyRoom" @click="newRoom" color="primary" small fab dark><v-icon>mdi-plus</v-icon></v-btn>
            <v-btn v-if="newPartyRoom" @click="createNewRoom" depressed color="#00aff2" dark>Guardar</v-btn>
          
            <v-spacer></v-spacer>
            <div style="text-align: right">
              <span style="font-size: 10px">
                Última actualización: {{ $dayjs(roomSelected.updatedAt).format('ll') }}
              </span>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="padding-card">
          <p class="title-user-scr"> <v-icon> mdi-cash </v-icon> Subir Saldos </p>
          <v-row>
            <v-col sm="6">
              <v-autocomplete                               
                v-model="saldoYear"                      
                :items="getLastFiveYears()"
                filled
                label="Selecciona el año"
              >
              </v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-file-input
                  v-model="csv"
                  accept="text/csv"
                  label="Subir CSV"
                  :rules="[rules.required]"
                ></v-file-input>
            </v-col>
          </v-row>   
          <v-card-actions>
            <v-btn @click="subirCsv" depressed color="#00aff2" dark>Cargar Saldos</v-btn>
          </v-card-actions>       
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserAdminForm from '../../components/UserAdminForm.vue';
import ModalNewPlan from '@/components/ModalNewPlan.vue';
import adminSettingsService from '@/services/admin/config';
import adminRoomsService from '@/services/admin/partyRooms';
import adminUserService from '@/services/users';
import adminScheduleMaintenanceService from '@/services/admin/maintenancePayments';
import ModalMaintenancePaymentsUsers from '@/components/ModalMaintenancePaymentsUsers.vue';
import TimePicker from '@/components/TimePicker2.vue';

export default {
  components: {
    UserAdminForm,
    ModalMaintenancePaymentsUsers,
    ModalNewPlan,
    TimePicker
  },
  data() {
    return {
      show1: false,
      show2: false,
      concept: '',
      description: '',
      paymentYear: 2021,
      paymentDueDay: 5,
      amount: 0,
      maintenanceFeeId: null,
      validFormSchedule: true,
      validForm: true,
      validFormProfile: true,
      months: [],
      settings: [],
      nextDay: false,
      newPartyRoom: false,
      rules: {
        required: (value) => !!value || 'Required.',
        surchargePercentage: [
          (v) => !!v || 'Recargo es requerido',
          (v) => v <= 100 || 'El porcentaje debe estar entre 0 y 100',
          (v) => v >= 0 || 'Recargo debe ser mayor o igual a cero',
        ],
        surchargeFixed: [
          (v) => !!v || 'Recargo es requerido',
          (v) => v <= 100000 || 'El rango permitido es de 0 a 10000',
          (v) => v >= 0 || 'Recargo debe ser mayor o igual a cero',
        ],
        name: [
          (v) => !!v || 'Nombre is required',
          (v) => v.length <= 60 || 'Nombre debe ser menor a 60 caracteres ',
          (v) => v.length >= 2 || 'Nombre debe ser mayor a 2 caracteres ',
        ],
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => `The email and password you entered don't match`,
        email: [(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],        
      },
      surchargeType: '',
      surchargeValue: 0,
      reservationBlockSize: 1,
      comisionPagoTarjeta: 4,
      profile: {
        username: '',
        email: '',
      },
      password: '',
      confirmPassword: '',
      rooms: [],
      validFormRoom: null,
      roomSelected: {},
      image: null,
      csv: null,
      saldoYear: '2025',
      timeError: '',
      year: new Date().getFullYear(), // año actual por default
      years: [],
    };
  },
  created() {
    this.fetch();
    this.fetchSchedulePayment();
    this.fetchProfile();
    this.fetchRooms();
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let y = 2025; y <= currentYear; y++) {
      this.years.push({
        text: y.toString(),
        value: y,
      });
    }   
  },
  methods: {
    validateTimeRange() {
      const start = this.roomSelected.timeStart;
      const end = this.roomSelected.timeEnd;
      const nextDay = this.roomSelected.nextDay;

      this.timeError = ''; // Reinicia mensaje

      if (!start || !end) return true;

      const [startHour, startMin] = start.split(':').map(Number);
      const [endHour, endMin] = end.split(':').map(Number);

      const startMinutes = startHour * 60 + startMin;
      const endMinutes = endHour * 60 + endMin;

      if (nextDay && endMinutes >= startMinutes) {
        this.timeError = 'Error: La hora final debe ser menor que la inicial si es el día siguiente.';
        return false;
      } else if (!nextDay && endMinutes <= startMinutes) {
        this.timeError = 'Error: La hora final debe ser mayor que la inicial si es el mismo día.';
        return false;
      }
      return true;
    },
    selectFileRoom(file) {
      this.image = file;
    },
    updateRoom() {
      if (!this.validateTimeRange()) {
        // No continúa si la validación falla
        return;
      }
      if (this.$refs.formRoom.validate()) {
        const depositAmount = this.roomSelected.depositAmount * 100;
        const costAmount = this.roomSelected.costAmount * 100;
        if (!Number.isInteger(depositAmount) || !Number.isInteger(costAmount)) {
          this.$swal(
            'Cobro de Salones',
            'El cobro de salones debe tener a lo más dos decimales, valide el cobro de deposito o el cobro total.',
            'warning'
          );
          return;
        }
        const formData = new FormData();

        if (this.image) {
          formData.append('image', this.image, this.image.name);
        }
        formData.append('title', this.roomSelected.title);
        formData.append('subtitle', this.roomSelected.subtitle);
        formData.append('description', this.roomSelected.description);
        formData.append('deposit', this.roomSelected.deposit);
        formData.append('noPayment', this.roomSelected.noPayment);
        formData.append('lapse', this.roomSelected.lapse);
        formData.append('dias_min_reserva', this.roomSelected.dias_min_reserva || 1);
        formData.append('blocked', this.roomSelected.blocked);
        formData.append('timeStart', this.roomSelected.timeStart);
        formData.append('timeEnd', this.roomSelected.timeEnd);
        formData.append('nextDay', this.roomSelected.nextDay);
        formData.append('depositAmount', depositAmount);
        formData.append('costAmount', costAmount);

        adminRoomsService
          .update(this.roomSelected.id, formData)
          .then(() => {
            this.$swal('Salón actualizado', 'Salón actualizado con éxito', 'success');
            this.fetchRooms();
            this.image = null;
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al actualizar salón', error.response.data.message, 'warning');
            }
          });
      }
    },
    newRoom() {
      this.roomSelected = {
        deposit:false,
        noPayment:false,
        lapse: 1,
        dias_min_reserva: 0,
        blocked: false,
        nextDay: false,
        timeStart: "07:00",
        timeEnd: "22:00",
        depositAmount:0,
        costAmount:0,
        title:"",
        subtitle:"",
        description:""
      };
      this.newPartyRoom = true;
    },
    createNewRoom() {
      if (!this.validateTimeRange()) {
        // No continúa si la validación falla
        return;
      }
      if (this.$refs.formRoom.validate()) {
        const depositAmount = this.roomSelected.depositAmount * 100;
        const costAmount = this.roomSelected.costAmount * 100;
       
        const formData = new FormData();

        if (this.image) {
          formData.append('image', this.image, this.image.name);
        }
        formData.append('title', this.roomSelected.title);
        formData.append('subtitle', this.roomSelected.subtitle);
        formData.append('description', this.roomSelected.description);
        formData.append('deposit', this.roomSelected.deposit);
        formData.append('noPayment', this.roomSelected.noPayment);
        formData.append('lapse', this.roomSelected.lapse);
        formData.append('dias_min_reserva', this.roomSelected.dias_min_reserva || 1);
        formData.append('blocked', this.roomSelected.blocked);
        formData.append('timeStart', this.roomSelected.timeStart);
        formData.append('timeEnd', this.roomSelected.timeEnd);
        formData.append('nextDay', this.roomSelected.nextDay);
        formData.append('depositAmount', depositAmount);
        formData.append('costAmount', costAmount);
        adminRoomsService
          .create(formData)
          .then(() => {
            this.$swal('Salón creado', 'Salón actualizado con éxito', 'success');
            this.fetchRooms();
            this.image = null;
            this.newRoomFalse();
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al actualizar salón', error.response.data.message, 'warning');
            }
          });
      }
    },
    newRoomFalse(){
       this.newPartyRoom = false;  
    },
    close() {
      this.dialog = false;
      this.fetchSchedulePayment();
    },
    fetchRooms() {
      adminRoomsService.fetch().then((response) => {
        this.rooms = response.data;
        this.rooms.forEach((item) => {
          item.costAmount = item.costAmount / 100;
          item.depositAmount = item.depositAmount / 100;
        });
        this.roomSelected = response.data[0];
      });
    },
    fetchSchedulePayment() {
      // const year = new Date().getFullYear();
      adminScheduleMaintenanceService.fetch(this.year).then((response) => {        
        this.months = response.data;
      });
    },
    fetchProfile() {
      adminUserService.user().then((response) => {
        this.profile = response.data;
      });
    },
    saveCurrentUser() {     
      if (this.$refs.formProfile.validate()) {
        const data = this.$refs.editUser.userData();
        adminUserService
          .updateUserAdmin(data.user)
          .then(() => {
            this.$swal('Perfil actualizado', 'Perfil actualizado con éxito', 'success');
            this.fetchProfile();
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al actualizar perfil', error.response.data.message, 'warning');
            }
          });
      }
    },
    fetch() {
      adminSettingsService.fetch().then((response) => {
        this.settings = response.data;
        this.surchargeType = this.settings.surchargeType;
        this.surchargeValue = this.settings.surchargeValue;
        if (this.settings.surchargeType === 'fixed') {
          this.surchargeValue = this.settings.surchargeValue / 100;
        }
        this.reservationBlockSize = this.settings.reservationBlockSize;
        this.comisionPagoTarjeta = this.settings.comisionPagoTarjeta;
      });
    },
    save() {
      if (this.$refs.formSettings.validate()) {
        let count = 0;
        if (
          this.surchargeType !== this.settings.surchargeType ||
          this.surchargeValue !== this.settings.surchargeValue / 100
        ) {
          let surchargeValue = this.surchargeValue;
          if (this.surchargeType === 'fixed') {
            surchargeValue = this.surchargeValue * 100;
            if (!Number.isInteger(surchargeValue)) {
              this.$swal('Cobro de recargos', 'El cobro de recargos debe tener a lo más dos decimales.', 'warninf');
              return;
            }
          }
          adminSettingsService
            .updateSurcharges(this.surchargeType, surchargeValue)
            .then(() => {
              this.$swal('Configuraciones', 'La configuración de recargo se a guardado correctamente.', 'success');
            })
            .catch((error) => {
              if (error.response && error.response.status === 400) {
                this.$swal('Error al actualizar configuraciones de recargo', error.response.data.message, 'warning');
              }
            });
        } else {
          count++;
        }

        if (this.reservationBlockSize !== this.settings.reservationBlockSize) {
          adminSettingsService
            .updateBlocksize(this.reservationBlockSize)
            .then(() => {
              this.$swal(
                'Configuraciones',
                'La configuración de ventana de reservación se a guardado correctamente.',
                'success'
              );
            })
            .catch((error) => {
              if (error.response && error.response.status === 400) {
                this.$swal('Error al actualizar ventana de reservación', error.response.data.message, 'warning');
              }
            });
        } else {
          count++;
        }

        if (this.comisionPagoTarjeta !== this.settings.comisionPagoTarjeta) {
          adminSettingsService
            .updateComisionTarjeta(this.comisionPagoTarjeta)
            .then(() => {
              this.$swal(
                'Configuraciones',
                'La comision para pagos con tarjeta se ha actualizado.',
                'success'
              );
            })
            .catch((error) => {
              if (error.response && error.response.status === 400) {
                this.$swal('Error al actualizar la comision pago con tarjeta', error.response.data.message, 'warning');
              }
            });
        } else {
          count++;
        }

        if (count === 3) {
          this.$swal('Configuraciones', 'No hay valores a actualizar.', 'success');
        }
      }
    }, 
    alertdeleteMaintFee(maintFee) {
      // Use sweetalert2
      this.$swal({
        title: '¿Desea eliminar el plan? ' + maintFee.concept,
        text: 'Esta acción es irreversible, se eliminarán todos los pagos relacionados a este plan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, ¡eliminar Plan de Cuotas!',
        cancelButtonText: 'No, ¡cancelar!',
        reverseButtons: true,
      }).then(async (result) => {       
        if (result.isConfirmed) {
           this.eliminatePlan(maintFee.id); 
        } else {
          this.$swal('Operación cancelada', 'No se eliminó el Plan de Cuotas', 'error');
        }
      });
    },    
    eliminatePlan(planId){
      adminScheduleMaintenanceService.eliminateMaintFee(planId)
      .then((res) => {
        console.log(res);
        this.$swal(
          'Planes de Mantenimiento',
          'El Plan de Cuotas fué eliminado correctamente.',
          'success'
        );
        this.fetchSchedulePayment();
      })
     .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 400) {
          this.$swal('Error al eliminar el Plan de Cuotas ', error.response.data.message, 'warning');
        } else if (error.response && error.response.status === 500) {
          this.$swal('Error al eliminar el Plan de Cuotas ', error.response.data.message, 'warning');
        } else {
          this.$swal('Error al eliminar el Plan de Cuotas ', error.response.data.message, 'warning');
        }
      });
    },
    subirCsv() {
      const formData = new FormData();
      if (this.csv) {
          formData.append('csvFile', this.csv, this.csv.name);
        }
      formData.append('saldoYear', this.saldoYear);

      adminUserService
        .loadCsv(formData).then((res) => {
          console.log(res.data);
          this.$swal('Configuraciones', res.data.msg, 'success');
        })
      .catch((error) => {
          console.log(error);
        });
    },
    normalizeTime(val) {
    // Asegura que sea HH:mm:ss
    if (val && val.length >= 5) {
      return val.substring(0,5); // convierte "07:00" → "07:00:00"
    }
    return val;
  },
  getLastFiveYears () {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const startYear = currentMonth >= 11 ? currentYear + 1 : currentYear;
      return this.lastFiveYears = Array.from({ length: 5 }, (_, i) => startYear - (4 - i));
    },
  },
  watch: {
    roomSelected(newVal) {   
      if (!newVal) return;
      this.roomSelected.blocked = !!newVal.blocked;
      this.roomSelected.nextDay = !!newVal.nextDay;
      console.log(newVal.dias_min_reserva);
      this.roomSelected.dias_min_reserva = newVal.dias_min_reserva;      
      console.log(this.roomSelected.dias_min_reserva);
    },    
  }
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, 
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
 .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: medium;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: medium;
}
</style>